var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('a',{staticClass:"yButton",attrs:{"href":_vm.href}},[_c('p',[_vm._v("ログイン")])]):_c('button',{staticClass:"yButton",on:{"click":_vm.handleClick}},[_c('p',[_vm._v("ログイン")])])}
var staticRenderFns = []

export { render, staticRenderFns }